import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AppShell from "@/components/AppShell";

import Dashboard from "@/pages/dealer/Dashboard";
import Products from "@/pages/dealer/Products";
import Cart from "@/pages/dealer/Cart";
import Wishlist from "@/pages/dealer/Wishlist";
import QuoteRequests from "@/pages/dealer/QuoteRequests";
import { OrdersList, OrderDetail } from "@/pages/dealer/Orders";
import Loyalty from "@/pages/dealer/Loyalty";
import Returns from "@/pages/dealer/Returns";
import Support from "@/pages/dealer/Support";
import Profile from "@/pages/dealer/Profile";
import MfaSettings from "@/pages/settings/Mfa";

export default function DealerDashboard() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell variant="dealer">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/quote-requests" element={<QuoteRequests />} />
        <Route path="/orders" element={<OrdersList />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/loyalty" element={<Loyalty />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/support" element={<Support />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings/mfa" element={<MfaSettings />} />
      </Routes>
    </AppShell>
  );
}
